$(function() {
    "use strict";

    $('.link-multi-hover').on('mouseenter', function() {
        var href = $(this).attr('href');
        $(document).find('.link-multi-hover[href="'+href+'"]').addClass('link_hover');
    });
    $('.link-multi-hover').on('mouseleave', function() {
        $('.link_hover').removeClass('link_hover');

    });
});